import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { DialogConfirmResponse, DialogModificarFechaRequest, EmpleadoDto, SaveEmpleadoComunidad, SaveEmpleadoDto } from '../../../../../src/app/shared/model';
import { EmpleadoService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-dialogModificarFecha',
  templateUrl: 'dialogModificarFecha.component.html',
  styleUrls: ['./dialogModificarFecha.component.css']
})

export class DialogModificarFechaComponent implements OnInit {

  public title: string;
  public message: string;
  public buttonAcceptText: string;
  public buttonCancelText: string;
  isSearching: boolean = false;
  isEmpleadoSaving: boolean = false;
  formGroup: FormGroup;
  empleado: EmpleadoDto;

  constructor(
    private dialogRef: MatDialogRef<DialogModificarFechaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModificarFechaRequest,    
    private formBuilder: FormBuilder,
    private empleadoService: EmpleadoService,
    private sharedFunctions: SharedFunctions,
    private datePipe: DatePipe) { 

  }

  ngOnInit() {
    this.loadView();
    this.title = 'Empleado';
    this.message = '¿Está seguro que desea continuar?';
    
    this.buttonAcceptText = 'Aceptar';
    this.buttonCancelText = 'Cancelar';
  }
  
  loadView() {
    this.buildForm();
    this.getEmpleado();
  }
  
  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
            this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  buildForm(){
    this.formGroup = this.formBuilder.group({
      'FechaIngreso':[null],
      'FechaEgreso':[null]
    });
  }

  getEmpleado(){
    this.empleadoService.get(this.data.EmpleadoId).subscribe(data => {
      this.isSearching = false;
      if (data != null && data.Success) {
        this.empleado = data.Result;
        this.empleado.PersonaId = data.Result.PersonaId;

        if (this.empleado != null && this.empleado.Id > 0) {        
          this.formGroup.get("FechaIngreso")?.setValue(this.datePipe.transform(this.empleado.Comunidades.find(x => x.ComunidadId == this.data.ComunidadId)?.FechaInicio, "yyyy-MM-dd" + "T00:00:00"));          
          this.formGroup.get("FechaEgreso")?.setValue(this.datePipe.transform(this.empleado.Comunidades.find(x => x.ComunidadId == this.data.ComunidadId)?.FechaFin, "yyyy-MM-dd" + "T00:00:00"));          
        }
        else
          this.message = "No se encontró la persona seleccionada.";
      }
      else
        this.message = "Ocurrió un error al intentar obtener los datos de la persona.";
    },
    (err: HttpErrorResponse) => {
      this.isSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  saveEmpleado() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var empleadoComunidad = this.empleado.Comunidades.find(x => x.ComunidadId == this.data.ComunidadId);
    var s = [new SaveEmpleadoComunidad(empleadoComunidad?.Id ?? 0, this.data.ComunidadId, this.data.EmpleadoId, this.formGroup.value.FechaIngreso, this.formGroup.value.FechaEgreso)];
    var r = new SaveEmpleadoDto(0, null, null, null, null,null,null,null,null,null,null,null,null,null,null,null,null,null, null, null,null,null,
      null,null,null,null,null,null,null,null,null,null,null,null, s,null, true);
      
    if (this.empleado != null) {
      Object.assign(r,this.empleado,this.formGroup.value);
  
      this.isEmpleadoSaving = true;
      this.empleadoService.save(r).subscribe(data => {
        this.isEmpleadoSaving = false;
        if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
          this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");        
          this.dialogRef.close(new DialogConfirmResponse(true));
        }
        else{
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          this.dialogRef.close(new DialogConfirmResponse(false));
        }
      },
        (err: HttpErrorResponse) => {
          this.isEmpleadoSaving = false;
          this.sharedFunctions.handleError(err, true);
        })
    }
  }

  onAccept() {
    this.saveEmpleado();
  }

  onDecline() {
    this.dialogRef.close(new DialogConfirmResponse(false));
  }
}